import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { useMessage } from '../../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../../hooks/services/interview-service';
import { useReportService } from '../../../../../hooks/services/report-service';

export const useReport = () => {
  const { getLastInterview } = useInterviewService();
  const { validetaReportOnline } = useReportService();
  const { handleError, handleAttention } = useMessage();
  const { getReportInterviewData } = useReportService();
  const { navigateTo } = Sebrae.useSebraeRouter();

  const [cpf, setCpf] = React.useState('');
  const [laoding, setLoading] = React.useState(true);

  const clearCpf = (valie = '') => {
    return valie.trim().replaceAll('.', '').replaceAll('-', '');
  };
  const handleChangeCpf = React.useCallback((value) => {
    setCpf(value);
  }, []);

  const handleGenerateSearch = React.useCallback(async () => {
    const cpfCleaned = clearCpf(cpf);
    const isValidCpf = cpfCleaned.length === 11;

    if (!isValidCpf) {
      handleError('CPF inválido!');
      return;
    }
    try {
      const result = await getLastInterview(cpfCleaned);
      const resultValidReport = await validetaReportOnline(result.id);
      if (result !== undefined && resultValidReport) {
        navigateTo(`/relatorio/${cpfCleaned}`, {
          keepQueryString: true,
        });
        setCpf(cpfCleaned);
        return;
      }
    } catch (error) {
      handleAttention(
        'Não foi encontrada entrevista válida para emissão do relatório de perfil vinculado ao CPF informado.',
      );
    }
  }, [
    cpf,
    handleError,
    navigateTo,
    handleAttention,
    validetaReportOnline,
    getLastInterview,
  ]);

  const getStepData = React.useCallback(
    async ({ cpf = '', step = '' }) => {
      setLoading(true);
      try {
        const cpfValue = clearCpf(cpf);
        const result = await getReportInterviewData({ cpf: cpfValue, step });
        setLoading(false);
        return result;
      } catch (error) {
        setLoading(false);
        handleError('Erro ao buscar informações do', step);
      }
    },
    [getReportInterviewData, handleError],
  );

  return {
    handleGenerateSearch,
    handleChangeCpf,
    getStepData,
    cpf,
    laoding,
  };
};
